angular.module('unica_media.media_controllers', [])

.controller('MediaBasicController',
	function(
		$rootScope, $scope, $stateParams,
		FileUploader, getBaseApiURL, Session,
		MediaDeleteService
	) {

	$scope.forms = {};

	$scope.uploader =  new FileUploader({
		removeAfterUpload: true,
		alias: 'files',
		url: getBaseApiURL + '/event/upload-media',
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$rootScope.mediaData = {
		event_id: $stateParams.event_id,
		files: []
	};

	$scope.deleteWorkshopMaterial = function( mediaId ) {
		$scope.showLoader();
		MediaDeleteService
			.deleteMedia( mediaId )
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$rootScope.mediaData = data;
					//$scope.showSuccessMsg('Materiale Workshop rimosso con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	};

});


